<template>
  <div class="d-flex flex-wrap">
    <span
      v-for="tag in tags"
      :key="tag.slug"
      class="badge fs-6 me-2 mt-2 modview__grid-item__tag"
      :class="{ 'modview__grid-item__tag--highlight': tag.slug === 'popular' }"
    >
      <b>{{
        $t(`${tag.translationKey.namespace}/${tag.translationKey.key}`)
      }}</b>
    </span>
  </div>
</template>

<script lang="ts">
import type { StrapiMinecraftModpackTag } from '~/apollo/types/types';

export default defineComponent({
  props: {
    tags: {
      type: Array as PropType<Array<StrapiMinecraftModpackTag>>,
      required: true,
    },
  },
});
</script>

<style scoped lang="scss">
@import 'gportal-theme/scss/_colors.scss';

.modview__grid-item__tag {
  background: $gp-midnight-2;
  text-transform: capitalize;

  &--highlight {
    color: $primary;
  }
}
</style>
